"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _decorWrapper = _interopRequireDefault(require("./decor-wrapper"));
/**
 * DecorImages component for handling decorative imagery
 *
 * @param {Object} props React props
 * @param {Object} props.decorImage1 First decorative image
 * @param {Object} props.decorImage2 Second decorative image
 * @param {Object} props.decorImage3 Third decorative image
 * @param {Object} props.decorImageBg1 First background image
 * @param {Object} props.decorImageBg2 Second background image
 * @returns {React.ReactElement|null} DecorImages component or null
 */
function DecorImages({
  decorImage1,
  decorImage2,
  decorImage3,
  decorImageBg1,
  decorImageBg2
}) {
  if (!decorImage1 && !decorImage2 && !decorImage3) return null;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, decorImage1 && /*#__PURE__*/_react.default.createElement(_decorWrapper.default, {
    decorImage1,
    decorImage2,
    decorImage3,
    decorImageBg1,
    decorImageBg2
  }));
}
DecorImages.propTypes = {
  decorImage1: _propTypes.default.object,
  decorImage2: _propTypes.default.object,
  decorImage3: _propTypes.default.object,
  decorImageBg1: _propTypes.default.object,
  decorImageBg2: _propTypes.default.object
};
var _default = exports.default = DecorImages;